import { Link } from 'react-router-dom';
import { Brand } from '../components/Brand';

export function Home() {
  return (
    <main className="landing">
      <nav className="topbar"><Brand small /><Link to="/admin">Admin</Link></nav>
      <section className="landing__hero">
        <div className="eyebrow">ROAM PARTICIPANT MEDIA</div>
        <h1>Stories belong to the people who live them.</h1>
        <p>ROAM documents people, places and experiences at no cost to the people we feature. This private portal is where participants can review their story, share feedback before publication and access the media created with them.</p>
        <div className="button-row">
          <Link className="button button--light" to="/portal/beyond-the-helm-jorge-ortega">Open pilot portal</Link>
          <Link className="button button--ghost" to="/admin">Open admin</Link>
        </div>
      </section>
    </main>
  );
}
